module.exports = __webpack_public_path__ + "src/assets/img/guestlist_king3.8c87d0bd.jpg";